import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'embryo-CurrencyDropDown',
  templateUrl: './CurrencyDropDown.component.html',
  styleUrls: ['./CurrencyDropDown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CurrencyDropDownComponent implements OnInit {

   @Output() selectedCurrency : EventEmitter<any> = new EventEmitter();

   @Input() selectedValue : string = "TRY";

   currencyArray : any = [
      {
         code:"TRY",
         name:"Türkiye",
         image:"assets/images/turkey.png"
      },
      {
         code:"USD",
         name:"United States Doller",
         image:"assets/images/united-states.png"
      },
      {
         code:"EUR",
         name:"France",
         image:"assets/images/france.png"
      }
   ]

   constructor() { }

   ngOnInit() {
   }

   selectionChange(data) {
      if(data && data.value){
         this.selectedCurrency.emit(data.value);
      }
   }

}
